<div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <span class="mat-h3 m-0">HOLD ITEM LIST <small>List of compatible inoperative systems and deferred works according to MEL</small></span>
            <span class="spacer"></span>
            <mat-form-field style="height: 100%">
                <mat-select [(ngModel)]="selectedAircraftOption" (selectionChange)="chooseAircraft($event.value)">
                    @for (item of aircraftOptions; track item) {
                        <mat-option [value]="item.value">{{ item.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </mat-toolbar>
    </div>
    <div fxLayout="row" fxLayoutAlign="center none" fxFlexFill>
        <!--
    <div style="max-height: calc(100vh - 130px); overflow: auto; width: 100%">
      <mat-nav-list role="navigation" class="p-0">
        @for (helicopter of helicoptersArray; track $index) {
          <div (click)="chooseAircraft(helicopter)" class="aircraft" [ngClass]="{'is-active': helicopter.id === chosenAircraft?.id}">
            <div fxLayout="row">
              <mat-icon mat-list-icon class="m-15">flight_takeoff</mat-icon>
              <div mat-line class="mt-15" style="font-size: medium;">{{helicopter.registrationMark}}</div>
            </div>
          </div>
        }
      </mat-nav-list>
    </div>
    -->
        <mat-divider [vertical]="true"></mat-divider>
        <div style="width: 99% !important; height: calc(100vh - 130px)">
            <app-hold-item-list-table [aircraft]="chosenAircraft" [helicopterData]="helicopterData"></app-hold-item-list-table>
        </div>
    </div>
</div>
